export const toAbsoluteUrl = (value) => {
  if (!value) return "";
  const url = String(value).trim();
  if (!url) return "";
  if (/^data:/i.test(url)) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (typeof window === "undefined") return url;
  const prefix = url.startsWith("/") ? "" : "/";
  return `${window.location.origin}${prefix}${url}`;
};
